import React from "react"
import { ILink, IMenuItem } from "../../../../gatsby-graphql"
import MenuItem from "./menu-item"
import { MenuList, MenuWrapper } from "./menu-elements"

interface MenuProps {
  items?: IMenuItem[]
  locale?: string
}

const Menu = ({ items, locale }: MenuProps) => {
  if (!items || items.length === 0) {
    return <></>
  }

  return (
    <MenuWrapper>
      <MenuList>
        {items.map((item, index) => {
          return (
            <MenuItem
              menuItem={item.link as ILink}
              submenuItems={item.subLinks as ILink[]}
              locale={locale}
              key={index}
            />
          )
        })}
      </MenuList>
    </MenuWrapper>
  )
}

export default Menu
